import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { CommentsIcon } from '../icons';
import { Text } from '../ui';
export var CommentsBox = function (_a) {
    var _b = _a.commentsCount, commentsCount = _b === void 0 ? 0 : _b, _c = _a.commentsHandler, commentsHandler = _c === void 0 ? function () {
        return;
    } : _c;
    return (_jsxs("div", { className: 'flex items-center space-x-2 rounded-lg cursor-pointer text-gray-800 bg-vjwSecondary  px-2 py-1', onClick: function (e) {
            e.stopPropagation();
            e.preventDefault();
            commentsHandler();
        }, children: [_jsx(CommentsIcon, {}), _jsx(Text, { className: 'px-1 bg-white rounded-md text-sm font-medium', children: commentsCount })] }));
};
